// extracted by mini-css-extract-plugin
export default {"root":"Faqs_root__ghVF8","item":"Faqs_item__IymH3","panel":"Faqs_panel__Q77Fx","chevron":"Faqs_chevron__S-GQ2"};